/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ICalculationEditorScope extends ng.IScope {
        model: CalculationEditorModel;
        processConfigurationId: string;
        reloadTree: boolean;
        calculation: Wars.Domain.Model.Calculations.Calculation;
        isReadonly: boolean;
        togglePreviewMode: () => void;
        codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
    }

    export class CalculationEditor implements IDirective {
        public link($scope: ICalculationEditorScope, element: JQuery, attrs: ng.IAttributes, controller: CalculationEditorController) { }
        public templateUrl = './app/views/directives/calculate/calculationEditor.html';
        public restrict: string = 'E';
        public controller = ['$scope', '$q', 'calculationService', "systemLevelService", "manageSystemCodesService", 'tagService', CalculationEditorController];
        public controllerAs = 'controller'; 
        public scope: any = {
            processConfigurationId: "=",
            calculation: "=",
            isReadonly: '='
        };
    }

    export class CalculationEditorModel {
        private calculationService: services.CalculationService;

        public treeData: any;
        public processConfigurationId: string;
        public excludeItem: models.TreeConfigurationItem;
        public tags: string[];
        public calculationTags: string[];
        public $q: ng.IQService;

        constructor(
            public calculation: Wars.Domain.Model.Calculations.Calculation,
            processConfigurationId: string,
            public schemaChangedCallback: () => void,
            calculationService: services.CalculationService,
            private tagService: services.TagService,
            $q: ng.IQService)
        {
            this.calculation = calculation;
            this.processConfigurationId = processConfigurationId;
            this.calculationService = calculationService;
            this.excludeItem = new models.TreeConfigurationItem();
            this.excludeItem.calculationId = this.calculation.id;
            this.$q = $q;
        }

        public addTag(tag) {
            var newTag = this.tagService.createTag();
            newTag.tagName = tag.text;
            newTag.tagType = Wars.Domain.Model.Codes.Enums.TagType.Condition;
            newTag.calculation_id = null;
            newTag.calculation_id = this.calculation.id;
            newTag.queryConfiguration_id = null;
            newTag.myCalculation = this.calculation;

            this.calculation.tags.push(newTag);
        }

        public removeTag(tag) {
            this.calculation.tags.forEach(t => {
                if (t.tagName === tag.text) {
                    t.entityAspect.setDeleted();
                }
            });
        }

        public searchTags(query: string) {
            var queryLength = query.length;
            var deferred = this.$q.defer();
            var returnTags = Enumerable.from(this.calculationTags)
                .where(i => i.substring(0, queryLength) === query)
                .toArray();
            deferred.resolve(returnTags);
            return deferred.promise;
        }
    }

    export class CalculationEditorController implements IController {

        constructor(
            private $scope: ICalculationEditorScope,
            $q: ng.IQService,
            calculationService: services.CalculationService,
            private systemLevelService: services.SystemLevelService,
            private manageCodeService: services.ManageSystemCodesService,
            tagService: services.TagService)
        {
            var schemaChangedFunction = () => {
                $scope.reloadTree = true;
            }
 
            $scope.model = new CalculationEditorModel($scope.calculation, $scope.processConfigurationId, schemaChangedFunction, calculationService, tagService, $q);

            $scope.model.calculationTags = [];
            tagService.getTagsLike(Wars.Domain.Model.Codes.Enums.TagType.Calculation)
                .then(result => {
                    $scope.model.calculationTags = Enumerable.from(result).select(i => i.tagName).distinct().toArray();
                });

            $scope.$watch("calculation", (newCalculation: Wars.Domain.Model.Calculations.Calculation) => {
                $scope.model.calculation = newCalculation;
                $scope.model.tags = [];
                $scope.model.excludeItem.calculationId = newCalculation.id;
                $scope.reloadTree = true;
                $scope.model.calculation.tags.forEach(t => {
                    $scope.model.tags.push(t.tagName);
                });
            });

            var listenerCallback = $scope.$on('operand-type-changed', () => {
                $scope.model.calculation.valueOperation.variableType = services.CalculationService.getValueOperationVariableType($scope.model.calculation.valueOperation);
            });

            $scope.$on("$destroy", () => {
                listenerCallback();
            });

            $scope.togglePreviewMode = () => {
                $scope.isReadonly = !$scope.isReadonly;
            }

            this.loadCodes();
        }

        private loadCodes(): void {
            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.$scope.codeGroups = systemLevel.myCodeGroups;
                    if (this.$scope.processConfigurationId) {
                        this.manageCodeService.getAllCodesForProcessConfiguration(this.$scope.processConfigurationId).then(
                            (codeGroups) => {
                                this.$scope.codeGroups = this.$scope.codeGroups.concat(codeGroups);
                            });
                    }
                });
        }
    }
}

warsApp.registerDirective('CalculationEditor', []);